import {CalendarDay} from './types';

export const getCalendarRange = (days: CalendarDay[]) => ({
  from: days[0].date,
  to: days[days.length - 1].date,
});
